import {
  Sparkles,
  Wallet,
  Timer,
  Truck,
  CalendarClock,
  ShieldCheck,
} from "lucide-react";

const features = [
  {
    icon: Sparkles,
    title: "Fresh & Hygienic",
    desc: "Fresh chicken daily, clean kitchen and strict hygiene practices.",
    bg: "#FFFFFF",
  },
  {
    icon: Wallet,
    title: "Affordable Pricing",
    desc: "Student and family friendly — great portions without stretching your wallet.",
    bg: "#FFB800",
  },
  {
    icon: Timer,
    title: "Quick Service",
    desc: "Place your order and enjoy a hot plate in minutes.",
    bg: "#FFFFFF",
  },
  {
    icon: Truck,
    title: "Home Delivery",
    desc: "Min order ₹300 + ₹45 delivery. Order on WhatsApp or call — we deliver hot and fresh!",
    bg: "#D92525",
    text: "white",
  },
  {
    icon: CalendarClock,
    title: "Pre-Orders Available",
    desc: "Planning ahead? Pre-book your order for a specific time so it's ready when you arrive.",
    bg: "#FFFFFF",
  },
  {
    icon: ShieldCheck,
    title: "Trusted by Locals",
    desc: "4.1 star rating and loyal regulars — the trusted KKFC experience in Bangarpet.",
    bg: "#111111",
    text: "white",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-[#FFF9E6] border-b-2 border-black"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="max-w-3xl mb-10 md:mb-14">
          <div className="inline-block brutal-border bg-white px-3 py-1 text-xs font-bold uppercase tracking-widest mb-4">
            Why Choose Us
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] text-black">
            So many reasons, <br />
            <span className="text-[#D92525]">so little time</span>.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((f, idx) => {
            const Icon = f.icon;
            const isDark = f.text === "white";
            return (
              <div
                key={f.title}
                data-testid={`why-card-${idx}`}
                className="brutal-border brutal-shadow p-6 md:p-7 min-h-[200px] flex flex-col gap-4"
                style={{
                  backgroundColor: f.bg,
                  color: isDark ? "#FFFFFF" : "#111111",
                }}
              >
                <div
                  className="w-12 h-12 brutal-border flex items-center justify-center"
                  style={{
                    backgroundColor: isDark ? "#FFB800" : "#111111",
                  }}
                >
                  <Icon
                    size={22}
                    strokeWidth={2.5}
                    color={isDark ? "#111111" : "#FFB800"}
                  />
                </div>
                <h3 className="font-display text-2xl md:text-3xl uppercase leading-tight">
                  {f.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed ${isDark ? "text-neutral-200" : "text-neutral-800"}`}
                >
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
